// Facility default currency (findings #99), kept in `Farm.metadata.currency`
// (no migration). New costs, Inventario prices and lots with no cost yet use it
// instead of USD; records already saved keep their own currency.

export const FACILITY_CURRENCIES = ['PEN', 'USD'] as const
export const FALLBACK_CURRENCY = 'USD'

type WithMetadata = { metadata?: Record<string, unknown> | null } | null | undefined

/** The facility's currency (3-letter ISO code), or null when none is set. */
export const readFacilityCurrency = (farm: WithMetadata): string | null => {
  const raw = farm?.metadata?.currency
  if (typeof raw !== 'string') return null
  const code = raw.trim().toUpperCase()
  return /^[A-Z]{3}$/.test(code) ? code : null
}

export const facilityCurrencyOrFallback = (farm: WithMetadata): string =>
  readFacilityCurrency(farm) ?? FALLBACK_CURRENCY
